import type { IconSvgObject } from './types';

const HazeIcon: IconSvgObject = [
  ["path", { d: "M16 12.4941C16 10.285 14.2091 8.49414 12 8.49414C9.79086 8.49414 8 10.285 8 12.4941", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 18.5H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 15.5H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M10 21.5H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M2 12.495H4M20 12.495H22M11.995 4.5V2.5M17.6533 6.84047L19.0675 5.42626M6.33963 6.84837L4.92542 5.43415", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default HazeIcon;
